import { Skeleton } from '@/shared/components/ui/skeleton';
import { Card } from '@/shared/components/ui/card';
import { OfficeMapSkeleton } from './OfficeMapSkeleton';

/**
 * Full-page skeleton for the booking page.
 * Shows a two-column layout with calendar/navigation on left and main content on right.
 */
export function BookingPageSkeleton() {
  return (
    <div className="px-2 sm:px-4 py-2" aria-busy="true" aria-label="Loading booking page">
      <div className="m-auto max-w-7xl 2xl:max-w-[2000px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
          {/* Left Column - Calendar & Navigation */}
          <div className="lg:col-span-5 xl:col-span-4 2xl:col-span-3">
            <Card className="border-0 shadow-sm lg:sticky lg:top-4">
              <div className="space-y-5">
                {/* Office name, its two icon buttons and the map or list switch */}
                <div className="flex min-h-8 items-center gap-1">
                  <Skeleton className="h-7 w-28" />
                  <Skeleton className="size-6 rounded" />
                  <Skeleton className="size-6 rounded" />
                  <Skeleton className="ml-auto h-8 w-[4.125rem] rounded-lg" />
                </div>

                {/* WeekCalendar: the date between the week arrows, then the days */}
                <div className="space-y-5">
                  <div className="flex items-center gap-2">
                    <Skeleton className="size-9 rounded-lg" />
                    <Skeleton className="h-9 flex-1 rounded-lg" />
                    <Skeleton className="size-9 rounded-lg" />
                  </div>
                  <div className="grid grid-cols-7 gap-2">
                    {Array.from({ length: 7 }).map((_, i) => (
                      <Skeleton key={i} className="h-[74px] rounded-lg" />
                    ))}
                  </div>
                </div>

                {/* The selected day: how many people, with the treats button */}
                <div className="space-y-3 border-t border-border/60 pt-4">
                  <div className="flex min-h-8 items-center gap-4">
                    <Skeleton className="h-5 w-20" />
                    <Skeleton className="ml-auto h-8 w-14 rounded-lg" />
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Right Column - Main Content (Map/List) */}
          <div className="lg:col-span-7 xl:col-span-8 2xl:col-span-9">
            <OfficeMapSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
}
